import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-moon',
  templateUrl: './icon-moon.component.html',
  styleUrls: ['./icon-moon.component.scss']
})
export class IconMoonComponent implements OnInit {
  @Input() color: string = '#262628';
  @Input() size: number = 18;

  constructor() { }

  ngOnInit() {
  }

}
